export const profileApiPath = {
  putShopIntroduction: '/v2/curator/shop/introduction',
  putProfileImage: '/v2/curator/profile-image',
  putCuratorNickname: '/v2/curator/nickname',
  getNicknameRecommendation: '/v2/curator/nickname/recommendation',
  getCuratorNicknameChangeCount: '/v2/curator/nickname/change-count',
  getCuratorNicknameCheckDuplicate: '/v2/curator/nickname/check-duplicate',
  putCuratorSns: '/v2/curator/sns',
  getCuratorUserInfo: '/v2/curator/user-info',
  getCuratorProfileBySnsTitle: (snsTitle: string) => `/v2/curator/profile/${snsTitle}`,
} as const;
